import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import PropTypes from 'prop-types';
// import classnames from 'classnames';

// import Typography from '@material-ui/core/Typography';
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
// import Divider from '@material-ui/core/Divider';

import ImageCard from './imageCard.jsx'
import UploadModal from "./UploadModal";

import styles from "assets/jss/material-kit-pro-react/views/componentsSections/sectionCards.jsx";

class PropertyImages extends React.Component {
  state = {
    expanded: false,
    images: [
      { id: "1", url: "1.jpg" },
      { id: "2", url: "2.jpg" },
      { id: "3", url: "3.jpg" }
    ]
   };

  handleExpandClick = () => {
    this.setState(state => ({ expanded: !state.expanded }));
  };

  handleUploadCompleted = (id, url) => {
    console.log("handleUploadCompleted(), id:", id, " - url:", url);
    let images = this.state.images;
    images.push({ id, url });
    this.setState({ images });
  };

  renderImages = (oportunity) => {
    const images = oportunity.attributes.images;
    if (typeof images !== 'undefined' && images.length > 0) {
      return images.map(image =>
        <GridItem key={image.id} xs={12} sm={6} md={6} lg={4}>
            <ImageCard key={image.id} image={image} />
        </GridItem>
      )
    } else {
      return(
      <GridItem xs={12} sm={6} md={6} lg={4}>
          <h5>No docs</h5>
      </GridItem>
    )}
  };

  render() {
    const { classes } = this.props;
    const { oportunity } = this.props;
    return (
      <div id="morphingCards" className="cd-section">
        <div className={classes.container}>
          <div className={classes.title}>

            <h3>Oportunity docs</h3>
          </div>
          <GridContainer>

            {this.renderImages(oportunity)}

            <UploadModal handleUploadCompleted={this.handleUploadCompleted} />
        </GridContainer>
      </div>

    </div>

    );
  }
}

PropertyImages.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(PropertyImages);
